import { FC } from "react";

import { Enterprise, useTranslation } from "@ctra/i18n";
import { Charts, DownOutlined, Space } from "@ctra/components";
import { ChartEntity, ChartType } from "@ctra/api";
import { useGoogleAnalytics } from "@ctra/analytics";

import { GAActions } from "../../analytics";
import styles from "./ChartViewFilter.module.less";

const { ChartViewIcon, SimpleDropdown } = Charts;

interface ChartViewFilterProps {
  /**
   * current view
   */
  view: ChartEntity["view"];
  /**
   * available views/chart ids
   */
  views: Array<ChartEntity["view"]>;
  /**
   * handle view change
   * @param view
   */
  onViewChange: (view: ChartType) => void;
}

/**
 * Chart view switch
 * @param views
 * @param view
 * @param onViewChange
 * @constructor
 */
const ChartViewFilter: FC<ChartViewFilterProps> = ({ views, view, onViewChange }) => {
  const { t } = useTranslation();
  const { trackEvent, label } = useGoogleAnalytics<{ label: string }>();

  return (
    <SimpleDropdown<ChartEntity["view"]>
      values={views}
      currentValue={view}
      onChange={({ key }) => {
        /* istanbul ignore next */
        trackEvent(GAActions.changeChartType, { label: `${label} - ${key}` });
        onViewChange(key as ChartType);
      }}
      showLabel={true}
      getLabel={(key, { isToggle }) => (
        <Space align="center">
          {!!key && <ChartViewIcon view={key} />}
          {isToggle ? (
            <DownOutlined className={styles.Caret} />
          ) : (
            t<string>(Enterprise.chart.view(key as ChartEntity["view"]))
          )}
        </Space>
      )}
    />
  );
};

export default ChartViewFilter;
